import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { Flex } from '@/components';
import AnimatedCalendarCogIcon from '../../assets/AnimatedCalendarCogIcon';

const StyledDatePicker = styled.div`
  display: inline-block;
  width: 100%;
  
  .react-datepicker {
    font-family: Arial, sans-serif;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container input {
    border: 1px solid #b3b3b3;
    padding: 5px 10px 5px 30px; /* Agrega un padding extra a la izquierda para el icono */
    border-radius: 4px;
    font-size: 14px;
    width: 100%;
    background: #ffffff;
    color: #1F2937;
    box-sizing: border-box;
    position: relative;
  }

  .react-datepicker__input-container {
    position: relative;
  }

  /* Estilo para el icono dentro del input */
  .input-icon {
    position: absolute;
    left: -2px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
  }

  .react-datepicker__day {
    padding: 8px;
    cursor: pointer;
  }

  .react-datepicker__day--selected {
    background-color: #285ff6;
    color: #fff;
  }

  .react-datepicker__navigation {
    background-color: #f0f0f0;
    color: #333;
    border-radius: 50%;
    padding: 8px;
  }

  .react-datepicker__current-month {
    font-weight: bold;
  }
`;

const RangePicker = ({
  startDate,
  endDate,
  updateRange,
  placeholder = 'select_range'
}) => {
  const { t } = useTranslation();

  return (
    <StyledDatePicker>
      <div className="react-datepicker__input-container">
        <AnimatedCalendarCogIcon className="input-icon" size={20} stroke="#285ff6" />
        <DatePicker
          selectsRange={true}
          startDate={startDate}
          endDate={endDate}
          onChange={(val) => {
            updateRange(val);
          }}
          isClearable={true}
          placeholderText={t(placeholder)} // Este es el texto de placeholder
        />
      </div>
    </StyledDatePicker>
  );
};
export default RangePicker;
